import { PointTooltip, ResponsiveLine } from "@nivo/line";
import moment from "moment-jalaali";
import { useHistory, useLocation } from "react-router";
import { useQuery } from "../../../utils/hooks";
import DropDown, { DropdownOption } from "../../shared/dropdown";
import Dot from "./dot";

interface Props {
  data: any;
  chart_settings?: any;
  className?: string;
  icon?: string;
  title?: string;
  color?: string;
  tooltip?: PointTooltip;
  filterOptions?: DropdownOption[];
  filterKey?: string;
  filterLoading?: boolean;
}

const Line: React.FC<Props> = (props) => {
  const { data, chart_settings, className, icon, title, color, tooltip, filterOptions, filterKey, filterLoading } =
    props;
  const query = useQuery();
  const filter = filterKey && query.get(filterKey);
  const officeId = filter ? parseInt(filter) : null;
  const location = useLocation();
  const history = useHistory();
  const isDataLarge = data?.length > 0 && data[0].data?.length > 8;

  const handleDropdown = (value: string | number) => {
    if (filterKey) {
      if (value) {
        query.set(filterKey, value as string);
      } else {
        query.delete(filterKey);
      }
      history.push(`${location.pathname}?${query.toString()}`);
    }
  };

  return (
    <div className={`shadow rounded-md p-3 bg-pkc-white ${className}`}>
      <div className="flex justify-between">
        <div>
          <i style={{ color }} className={`pl-2 ${icon}`} />
          <span>{title}</span>
        </div>
        <div>
          {filterOptions && (
            <DropDown
              onChange={handleDropdown}
              empty="مطب فعالی وجود ندارد"
              loading={filterLoading}
              options={filterOptions}
              value={officeId}
            />
          )}
        </div>
      </div>
      <div className="h-72">
        <ResponsiveLine
          data={data}
          enableSlices="x"
          sliceTooltip={({ slice }) => {
            return (
              <div
                style={{
                  background: "white",
                  padding: "9px 12px",
                  boxShadow: "0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06)",
                }}
              >
                {slice.points.map((point) => {
                  return <div>{tooltip?.({ point })}</div>;
                })}
              </div>
            );
          }}
          colors={color || { scheme: "nivo" }}
          lineWidth={2}
          enableArea={false}
          enablePoints={false}
          enableGridX={false}
          enableGridY={true}
          margin={{ top: 5, right: 5, bottom: 50, left: 25 }}
          useMesh={true}
          axisTop={null}
          layers={["grid", "markers", "areas", "lines", "slices", "axes", "points", "legends", Dot]}
          axisRight={null}
          xScale={{ type: "time", format: "%Y-%m-%d", precision: "day", useUTC: false, nice: true }}
          xFormat={(v) => moment(v).format("jYYYY/jMM/jDD")}
          yScale={{ type: "linear", min: "auto", max: "auto", stacked: true, reverse: false }}
          enableCrosshair={false}
          axisBottom={{
            tickSize: 0,
            tickPadding: 6,
            tickRotation: -45,
            legendOffset: 55,
            legendPosition: "middle",
            tickValues: isDataLarge ? undefined : "every day",
            format: (v) => moment(v).format("jYYYY/jMM/jDD"),
          }}
          axisLeft={{
            tickSize: 0,
            tickPadding: 20,
            tickRotation: 0,
            legendOffset: -60,
            legendPosition: "middle",
          }}
          theme={{
            axis: {
              ticks: { text: { fontSize: 10, fontFamily: "vazir" } },
              legend: { text: { fontSize: 12, fontFamily: "vazir" } },
            },
          }}
          {...chart_settings}
        />
      </div>
    </div>
  );
};

export default Line;
